import { z } from 'zod';
import { servicesProviderPricingSchema, servicesProviderPricingDtoSchema } from '../ServicesProviderPricing.js';
import { serviceConfigSchema } from './SharedServiceConfig.js';

// ============================================================================
// Pricing Schemas
// ============================================================================
const freightServicePricingSchema = servicesProviderPricingSchema;
const freightServicePricingDtoSchema = servicesProviderPricingDtoSchema;
// ============================================================================
// Core Schema
// ============================================================================
const freightServiceConfigSchema = serviceConfigSchema.extend({
    pricing: z.array(freightServicePricingSchema),
});
// ============================================================================
// DTO Schema
// ============================================================================
const freightServiceConfigDtoSchema = serviceConfigSchema.extend({
    pricing: z.array(freightServicePricingDtoSchema),
});

export { freightServiceConfigDtoSchema, freightServiceConfigSchema, freightServicePricingDtoSchema, freightServicePricingSchema };
//# sourceMappingURL=FreightServiceConfig.js.map
